/**
 * Whether an edit to `item` must be persisted as a swap onto the calendar
 * currently being viewed rather than a direct update of the inherited
 * assignment.
 *
 * On a child calendar, a swap creates an assignment owned by that calendar, so
 * later edits can update it in place. On an athlete-level calendar an inherited
 * item can carry `swap: true` from a swap made on the parent calendar — that
 * assignment is not the athlete's, so every inherited item still needs its own
 * athlete-level swap.
 *
 * @param {Object} item - calendar item / assignment
 * @param {boolean} isAthleteLevelCalendar - true when an athlete is the current
 *   selection (a non-empty `selectedReduxAthlete`)
 * @returns {boolean}
 */
const isNonSwappedParentItem = (item, isAthleteLevelCalendar) => (
  isAthleteLevelCalendar ? !!item?.isInherited : !!(item?.isInherited && !item?.swap)
);

export default isNonSwappedParentItem;
